export const servicesData = {
  staging: {
    title: "Home Staging",
    icon: "🎨",
    description: "Professional staging makes homes sell faster and for more money",
    services: [
      {
        name: "Complete Staging & Design",
        icon: "🏠",
        tagline: "Professional home staging for DFW sellers",
        description: "Virtual & physical staging services across Dallas, Fort Worth, and Plano. Make your home stand out with professional staging that helps buyers visualize their future.",
        benefits: [
          "DFW-wide coverage across Dallas, Fort Worth, and Plano",
          "Quick installation turnaround time",
          "Both virtual and physical staging options",
          "Professional design consultation included",
          "Proven to increase sale prices by 5-15%"
        ],
        price: "$500-$2,500",
        specialOffer: "Mention Its-Sold.com for 10% off your first staging",
        whyRecommended: "Staged homes sell 73% faster and for 5-15% more. This investment pays for itself.",
        url: "https://www.completestaginganddesign.com",
        color: "bg-amber-50",
        badge: "DFW"
      },
      {
        name: "DFW Staging",
        icon: "🎭",
        tagline: "Custom staging plans for North Texas",
        description: "Custom staging plans specifically designed for Dallas, Frisco, and Southlake suburbs. Local expertise that understands DFW buyer preferences.",
        benefits: [
          "North Texas specialist with local market knowledge",
          "Custom plans tailored to your home and neighborhood",
          "30-day tracking and support",
          "Volume tier bonuses for multiple properties",
          "Quick turnaround for competitive markets"
        ],
        price: "$600-$3,000",
        specialOffer: "$50/lead + 10% on rentals",
        whyRecommended: "Local expertise means your home is staged to appeal specifically to DFW buyers.",
        url: "https://www.dfw-staging.com",
        color: "bg-amber-50",
        badge: "DFW"
      },
      {
        name: "Charter Furniture Solutions",
        icon: "✨",
        tagline: "High-end staging for luxury homes",
        description: "Premium staging services for high-end properties in Dallas and Fort Worth metro area. Luxury furniture and designer touches that attract serious buyers.",
        benefits: [
          "High-end furniture and decor options",
          "DFW-specific logistics and delivery",
          "Fast professional setup",
          "Designer consultation included",
          "Perfect for homes $500K+"
        ],
        price: "$1,500-$5,000",
        specialOffer: "10-15% commission for referrals",
        whyRecommended: "For luxury properties, professional high-end staging is essential to attract qualified buyers.",
        url: "https://www.charterfurnituresolutions.com/home-staging",
        color: "bg-purple-50",
        badge: "LUXURY"
      },
      {
        name: "Virtual Staging Solutions",
        icon: "🖼️",
        tagline: "Affordable virtual staging nationwide",
        description: "Professional virtual staging using AI and design expertise. Perfect for vacant homes or budget-conscious sellers.",
        benefits: [
          "Nationwide service, fast turnaround",
          "Multiple room styles to choose from",
          "Unlimited revisions included",
          "Perfect for online listings",
          "90% cheaper than physical staging"
        ],
        price: "$29-$99 per room",
        specialOffer: "First room free for Its-Sold.com users",
        whyRecommended: "Virtual staging is perfect for online listings and costs a fraction of physical staging.",
        url: "https://virtualstagingsolutions.com/affiliate/?ref=its-sold",
        color: "bg-blue-50",
        badge: "VIRTUAL"
      }
    ]
  },
  photography: {
    title: "Professional Photography & Video",
    icon: "📸",
    description: "High-quality photos and videos are essential for selling homes fast",
    services: [
      {
        name: "360 Photo DFW",
        icon: "📷",
        tagline: "Complete DFW real estate photography",
        description: "Full-service real estate photography including aerial drone shots, 3D Matterport tours, and professional editing. Fast 24-hour turnaround, MLS-ready packages.",
        benefits: [
          "Aerial drone photography (FAA certified)",
          "Matterport 3D virtual tours",
          "Professional HDR photography",
          "24-hour turnaround time",
          "MLS-ready packages $199-$249"
        ],
        price: "$199-$249",
        specialOffer: "Complete packages with drone + ground photos",
        whyRecommended: "DFW specialist with fastest turnaround times. Listings with professional photos sell 32% faster.",
        url: "https://www.360photodfw.com",
        color: "bg-blue-50",
        badge: "DFW"
      },
      {
        name: "DFW Drone Footage",
        icon: "🚁",
        tagline: "Aerial photography & video specialists",
        description: "Professional aerial drone photography and video services by FAA-certified pilots. Stunning bird's eye views that make your property stand out.",
        benefits: [
          "FAA-certified drone pilots",
          "4K aerial video and photos",
          "Professional editing included",
          "Showcase property boundaries and features",
          "Same-day service available"
        ],
        price: "$150-$400",
        specialOffer: "Bundle ground + aerial photography",
        whyRecommended: "Aerial shots help buyers visualize the full property. Homes with drone footage get 68% more online engagement.",
        url: "https://dfwdronefootage.com/dallas-fort-worth-drone-photography-video/",
        color: "bg-blue-50",
        badge: "DFW"
      },
      {
        name: "AccuPhotography",
        icon: "⚡",
        tagline: "24-hour delivery guarantee",
        description: "Fast, professional real estate photography with next-day delivery. FAA-certified drone services, HD video tours, and stunning twilight shots.",
        benefits: [
          "24-hour delivery guaranteed",
          "FAA-certified drone pilots",
          "HD video tours available",
          "Twilight photography",
          "Professional HDR editing"
        ],
        price: "$175-$350",
        specialOffer: "Book 3 shoots, get 10% off",
        whyRecommended: "Need photos fast? 24-hour delivery perfect for quick listings.",
        url: "https://accuphotography.com",
        color: "bg-blue-50",
        badge: "FAST"
      },
      {
        name: "HomeJab",
        icon: "🎬",
        tagline: "Complete visual marketing solution",
        description: "Professional photography, video tours, 3D virtual tours, and floor plans. Used by thousands of agents nationwide.",
        benefits: [
          "Photography + video bundles",
          "3D virtual tours (Matterport)",
          "Floorplan services",
          "Social media-ready content",
          "Next-day delivery available"
        ],
        price: "$150-$500",
        specialOffer: "First-time customer discount available",
        whyRecommended: "Complete marketing package in one service. Homes with virtual tours get 87% more views.",
        url: "https://www.homejab.com/",
        color: "bg-purple-50",
        badge: "COMPLETE"
      },
      {
        name: "VHT Studios",
        icon: "🎥",
        tagline: "Trusted by leading real estate professionals",
        description: "National provider of professional real estate photography, video tours, and virtual staging services with proven results.",
        benefits: [
          "Professional photography packages",
          "Cinematic video tours",
          "Virtual staging available",
          "Nationwide coverage",
          "Trusted by 40,000+ agents"
        ],
        price: "$200-$500",
        whyRecommended: "Industry leader with proven track record. Homes photographed by VHT sell 50% faster on average.",
        url: "https://www.vhtstudios.com",
        color: "bg-blue-50",
        badge: "TRUSTED"
      },
      {
        name: "BoxBrownie",
        icon: "✨",
        tagline: "Photo editing & enhancement",
        description: "Professional photo editing, virtual staging, day-to-dusk conversions, and item removal. Make your existing photos pop!",
        benefits: [
          "Virtual staging ($32/image)",
          "Day-to-dusk conversions",
          "Item removal and touch-ups",
          "Sky replacement",
          "24-hour turnaround"
        ],
        price: "$1.60-$32 per image",
        specialOffer: "First 3 images free for new customers",
        whyRecommended: "Already have photos? Professional editing can transform them for a fraction of the cost of a new shoot.",
        url: "https://www.boxbrownie.com/",
        color: "bg-amber-50",
        badge: "EDITING"
      },
      {
        name: "CloudPano Virtual Tours",
        icon: "🌐",
        tagline: "DIY 360° virtual tours",
        description: "Create your own professional 360° virtual tours with easy-to-use software. Perfect for tech-savvy sellers who want to save money.",
        benefits: [
          "Easy DIY virtual tour software",
          "No photographer needed",
          "Unlimited tours & hosting",
          "Works with any 360° camera",
          "Monthly plans from $14/month"
        ],
        price: "$14-$49/month",
        specialOffer: "14-day free trial",
        whyRecommended: "Save hundreds by creating your own virtual tours. Great for tech-savvy sellers.",
        url: "https://www.cloudpano.com/",
        color: "bg-green-50",
        badge: "DIY"
      }
    ]
  },
  moving: {
    title: "Moving Services",
    icon: "🚚",
    description: "Professional movers to make your transition smooth",
    services: [
      {
        name: "MUVR",
        icon: "🚛",
        tagline: "On-demand moving and labor",
        description: "Flexible moving services with hourly rates. Perfect for local moves, loading/unloading, or just needing extra hands.",
        benefits: [
          "Hourly rates, no hidden fees",
          "Book same-day or schedule in advance",
          "Insurance included",
          "Professional movers",
          "Perfect for apartments and small homes"
        ],
        price: "$80-$120/hour (2 movers)",
        specialOffer: "Flexible scheduling and competitive rates",
        whyRecommended: "Pay only for what you need - no minimum charges or long contracts.",
        url: "https://www.muvr.io/business/affiliate-program/",
        color: "bg-green-50",
        badge: "DFW"
      },
      {
        name: "Unpakt",
        icon: "📦",
        tagline: "Compare moving quotes instantly",
        description: "Compare quotes from multiple moving companies in minutes. Find the best price and reviews for your move.",
        benefits: [
          "Compare multiple quotes at once",
          "Read verified reviews",
          "Instant online quotes",
          "Covers local and long-distance",
          "Save up to 30% on moving costs"
        ],
        price: "Free quotes",
        specialOffer: "Get 3 competitive quotes in 90 seconds",
        whyRecommended: "Shopping around saves an average of $400 on moving costs.",
        url: "https://www.unpakt.com",
        color: "bg-green-50",
        badge: "NATIONAL"
      },
      {
        name: "U-Haul",
        icon: "🚐",
        tagline: "DIY moving truck rentals",
        description: "Affordable truck and van rentals for do-it-yourself movers. Locations across DFW.",
        benefits: [
          "Multiple truck sizes available",
          "One-way or round-trip rentals",
          "Moving supplies available",
          "Locations throughout DFW",
          "Most affordable option for DIY"
        ],
        price: "$19.95+ per day",
        specialOffer: "Frequent promotions and discounts",
        whyRecommended: "Best option if you're comfortable doing the heavy lifting yourself.",
        url: "https://www.uhaul.com/",
        color: "bg-green-50",
        badge: "DIY"
      }
    ]
  },
  inspection: {
    title: "Home Inspection",
    icon: "🔍",
    description: "Know your home's condition before listing",
    services: [
      {
        name: "Pre-Listing Inspection",
        icon: "🏘️",
        tagline: "Find issues before buyers do",
        description: "Get a professional inspection before listing to identify and fix issues. Reduces surprises during buyer inspections.",
        benefits: [
          "Identify problems early",
          "Fix issues on your timeline",
          "Provides transparency to buyers",
          "Can prevent deal-killing surprises",
          "Demonstrates home is well-maintained"
        ],
        price: "$300-$500",
        whyRecommended: "Sellers who get pre-inspections close 25% faster and have fewer negotiations.",
        url: "https://www.internachi.org/find-an-inspector",
        color: "bg-purple-50",
        badge: "RECOMMENDED"
      }
    ]
  },
  repairs: {
    title: "Home Repairs & Improvements",
    icon: "🔧",
    description: "Fix issues and increase your home's value",
    services: [
      {
        name: "Handy",
        icon: "🛠️",
        tagline: "On-demand handyman services",
        description: "Professional handyman services for repairs, painting, and home improvements. Book online and schedule quickly.",
        benefits: [
          "Book online in minutes",
          "Vetted professionals",
          "Satisfaction guaranteed",
          "Wide range of services",
          "Competitive hourly rates"
        ],
        price: "$79-$129/hour",
        specialOffer: "$20 off first booking",
        whyRecommended: "Quick fixes before listing can increase your sale price by thousands.",
        url: "https://www.handy.com",
        color: "bg-orange-50",
        badge: "NATIONAL"
      },
      {
        name: "TaskRabbit",
        icon: "⚡",
        tagline: "Handyman and assembly services",
        description: "Find local handymen for repairs, furniture assembly, painting, and more. Same-day service available.",
        benefits: [
          "Same-day availability",
          "Read reviews before booking",
          "Transparent pricing",
          "Wide variety of tasks",
          "Insurance and vetted taskers"
        ],
        price: "$50-$100/hour",
        whyRecommended: "Perfect for small repairs and touch-ups that make a big difference to buyers.",
        url: "https://www.taskrabbit.com",
        color: "bg-orange-50",
        badge: "DFW"
      }
    ]
  },
  cleaning: {
    title: "Deep Cleaning",
    icon: "✨",
    description: "Make your home sparkle for showings",
    services: [
      {
        name: "Molly Maid",
        icon: "🧹",
        tagline: "Professional house cleaning",
        description: "Trusted professional cleaning services across DFW. Perfect for deep cleaning before photos and showings.",
        benefits: [
          "Licensed and insured",
          "Satisfaction guarantee",
          "Custom cleaning plans",
          "Recurring or one-time service",
          "Experienced teams"
        ],
        price: "$120-$280",
        specialOffer: "First cleaning discount available",
        whyRecommended: "A spotless home photographs better and makes a great first impression.",
        url: "https://www.mollymaid.com",
        color: "bg-blue-50",
        badge: "DFW"
      },
      {
        name: "The Maids",
        icon: "🏠",
        tagline: "America's maid service",
        description: "Professional cleaning with 22-step process. Perfect for preparing your home for the market.",
        benefits: [
          "22-step deep cleaning process",
          "Bonded and insured",
          "100% satisfaction guarantee",
          "Pet-friendly cleaning products",
          "Flexible scheduling"
        ],
        price: "$100-$250",
        whyRecommended: "Professional deep cleaning is essential before listing photos.",
        url: "https://www.themaids.com",
        color: "bg-blue-50",
        badge: "NATIONAL"
      }
    ]
  },
  legal: {
    title: "Legal & Title Services",
    icon: "📋",
    description: "Professional legal support for your transaction",
    services: [
      {
        name: "Real Estate Attorney",
        icon: "⚖️",
        tagline: "Legal guidance for FSBO sales",
        description: "Experienced real estate attorneys who can review contracts, handle closing, and protect your interests.",
        benefits: [
          "Contract review and preparation",
          "Title search and clearance",
          "Closing coordination",
          "Handles disclosures and paperwork",
          "Protects your legal interests"
        ],
        price: "$500-$1,500",
        whyRecommended: "Legal guidance is essential for FSBO transactions to avoid costly mistakes.",
        url: "https://www.texasbar.com/AM/Template.cfm?Section=Lawyer_Referral_Service_LRIS_",
        color: "bg-purple-50",
        badge: "TEXAS"
      },
      {
        name: "Title Company",
        icon: "📄",
        tagline: "Title insurance and closing services",
        description: "Professional title services including title search, insurance, and closing coordination.",
        benefits: [
          "Title search and insurance",
          "Coordinates closing",
          "Escrow services",
          "Prepares all closing documents",
          "Required for most sales"
        ],
        price: "$500-$2,000",
        whyRecommended: "Title insurance protects both you and the buyer from title issues.",
        url: "https://www.chicago-title.com",
        color: "bg-purple-50",
        badge: "REQUIRED"
      }
    ]
  }
};
